<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{ src: string; alt: string; width: number; height: number; eager?: boolean }>()
const resolvedSrc = computed(() => props.src.startsWith('http') || props.src.startsWith('/') ? props.src : `${import.meta.env.BASE_URL}${props.src}`)
</script>

<template>
  <figure class="product-frame">
    <div class="frame-bar" aria-hidden="true">
      <span /><span /><span /><span class="frame-address">app.pentestcamp / workspace</span>
    </div>
    <div class="frame-media">
      <img :src="resolvedSrc" :alt="alt" :width="width" :height="height" :loading="eager ? 'eager' : 'lazy'" :fetchpriority="eager ? 'high' : 'auto'" decoding="async" />
    </div>
  </figure>
</template>
